import "./TagContainer.css";

import { Tag } from "../Tag";

type TagsListType = {
  key: number;
  label: string;
  hasCloseIcon?: boolean;
};

export interface TagContainerProps {
  tagsList: TagsListType[];
}

export const TagContainer = ({ tagsList }: TagContainerProps): JSX.Element => {
  return (
    <div className="TagContainer">
      {tagsList.map((tag) => (
        <Tag key={tag.key} label={tag.label} hasCloseIcon={tag.hasCloseIcon} />
      ))}
    </div>
  );
};
